import { FunctionComponent, useMemo } from 'react';
import {
  IconAddressBook,
  IconBriefcase,
  IconBuildingCommunity,
  IconChartBar,
  IconListDetails,
  IconTools,
} from '@tabler/icons-react';
import { useGetMe } from '@/lib/api/me.ts';

interface MenuItem {
  title: string;
  icon: FunctionComponent;
  href: string;
}

export default function useMenuItems() {
  const { data: userData } = useGetMe();

  return useMemo(() => {
    const psiItems: MenuItem[] = [
      {
        title: 'Operaciones',
        icon: IconListDetails,
        href: '/inversiones',
      },
      {
        title: 'Oportunidades',
        icon: IconBuildingCommunity,
        href: '/oportunidades',
      },
    ];

    const investorItems: MenuItem[] = [
      {
        title: 'Dashboard',
        icon: IconChartBar,
        href: '/dashboard',
      },
      {
        title: 'Mis Inversiones',
        icon: IconBriefcase,
        href: '/inversiones',
      },
      {
        title: 'Oportunidades',
        icon: IconBuildingCommunity,
        href: '/oportunidades',
      },
      {
        title: 'PSIs',
        icon: IconAddressBook,
        href: '/psis',
      },
      {
        title: 'Herramientas',
        icon: IconTools,
        href: '/herramientas',
      },
    ];

    if (userData?.role === 'psi') {
      return psiItems;
    } else if (userData?.role === 'investor') {
      return investorItems;
    }

    return [];
  }, [userData?.role]);
}
